import React, { useState } from "react";
//import { createHashHistory } from "history";
import { useNavigate } from "react-router-dom";

import Cookies from "universal-cookie";
import Axios from "../config/AxiosConfig";
const cookies = new Cookies();

export default function Login() {
  const navigate = useNavigate();
  const [username, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const handleLogin = async () => {
    try {
      if (!username) {
        setError("please enter username");
        return;
      }
      if (!password) {
        setError("please enter password");
        return;
      }
      const login_request = await Axios.get("/login", {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          authorization: "user_id:" + username + ",pass:" + password,
        },
      });
      // axios itself handle 200 - 299 response as success response
      cookies.set("authorization", login_request.data.auth_token, {
        path: "/",
        maxAge: 86400,
      });
      navigate("/admin/posts");
    } catch (error) {
      console.log(error)
      setError("please enter valid credential");
    }
  };
  return (
    <div className="login-container">
      <div>
        <label htmlFor="username">User Name</label>
        <input
          type="text"
          id="username"
          value={username}
          placeholder="Enter username"
          onChange={(e) => {
            setUserName(e.target.value);
            setError("");
          }}
        />
      </div>
      <div>
        <label htmlFor="password">Password</label>
        <input
          type="password"
          id="password"
          value={password}
          placeholder="Enter password"
          onChange={(e) => {
            setPassword(e.target.value);
            setError("");
          }}
        />
      </div>
      <div>
        <p style={{ color: "red" }}>{error}</p>
      </div>
      <div style={{ margin: "10px", textAlign: "center" }}>
        <button className="btn-feed" onClick={handleLogin}>
          Login
        </button>
      </div>
    </div>
  );
}